/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Card,
  Collapse,
  Dropdown,
  Image,
  InputNumber,
  Tag,
} from "antd";
import { CaretRightOutlined, MoreOutlined } from "@ant-design/icons";
import SubServiceTable from "../../SubServiceTable";
import { useRef, useState } from "react";
import { DeleteIcon } from "../../../../../../atoms/CustomIcons";
import { PopUp } from "../../../../../../atoms/PopUp";
import ConfirmDelete from "../../../../../../atoms/ConfirmDelete";

export default function ServicesWithSub(props: any) {
  const {
    color,
    serviceGroup,
    inHouse,
    subContractor,
    highestVisit,
    companyId,
    groupData,
    groupIndex,
    setGroupedData,
    setActiveType,
    setActiveRecord,
    groupedData,
    totalSubServiceCost,
    totalSubServicePrice,
    setActiveServiceLineId,
    setActiveServiceId,
    setSelectedServiceIds,
  } = props;

  const [hrsPerVisit, setHrsPerVisit] = useState(0);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [confirmDelete, setConfirmDelete] = useState(false);

  let grossMargin = 0;
  if (totalSubServicePrice && totalSubServiceCost) {
    grossMargin = parseFloat(
      Number(
        ((totalSubServicePrice - totalSubServiceCost) / totalSubServicePrice) *
          100
      ).toFixed(1)
    );
  } else if (serviceGroup?.gross_margin_perc) {
    grossMargin = parseFloat(
      Number(serviceGroup?.gross_margin_perc).toFixed(1)
    );
  } else {
    grossMargin = 0;
  }

  const serviceItems = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Reset all service numbers to default
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setConfirmDelete(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          Remove service
        </Button>
      ),
    },
  ];

  const removeAllServiceTotals = () => {
    if (serviceGroup) {
      const serviceIdsToRemove = [
        ...(serviceGroup.services ?? []).map((s: any) => s.entity_id),
      ];

      setSelectedServiceIds((prev: any) =>
        prev.filter((id: any) => !serviceIdsToRemove.includes(id))
      );
    }

    setGroupedData(
      (prevData: any) =>
        prevData
          .map((item: any) => {
            if (item.service_line_id === groupData?.service_line_id) {
              const updatedItem = {
                ...item,
                service_groups: (item.service_groups || []).filter(
                  (group: any) => group.id !== serviceGroup?.id
                ),
                services: item.services || [],
              };

              // If both are empty, return null to filter later
              if (
                updatedItem.service_groups.length === 0 &&
                updatedItem.services.length === 0
              ) {
                return null;
              }

              return updatedItem;
            }
            return item;
          })
          .filter(Boolean) // remove nulls
    );
  };

  const deleteFunction = () => {
    setActiveRecord(null);
    setActiveType(null);
    setActiveServiceLineId(null);

    removeAllServiceTotals();
    setConfirmDelete(false);
  };

  const confirmDeleteService = {
    visibility: confirmDelete,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmDelete(false)}
        heading="Remove service from estimate"
        paragraph={
          <>
            This service will be removed from this estimate. <br />
            <br />
            Are you sure you want to remove it?
          </>
        }
        btnText="Remove service"
        btnApi={deleteFunction}
        loading={false}
        isArchivePopup={true}
      />
    ),
    width: 480,
    onCancel: () => setConfirmDelete(false),
  };
  return (
    <Card
      className={`${color} estimateServicesList`}
      style={{ cursor: "pointer" }}
    >
      <div className="top_wrap">
        <div className="top_wrap_left">
          <h4 style={{ marginBottom: "8px" }}>{serviceGroup?.name}</h4>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {inHouse && <img src="/images/estimate/tag_home.svg" alt="" />}
            {subContractor && (
              <img src="/images/estimate/tag_property.svg" alt="" />
            )}
            <Tag className="defaultTag default_tag">Complexity</Tag>

            {serviceGroup?.services?.some(
              (item: { frequency: string }) => item.frequency !== "one_time"
            ) && (
              <Tag
                className={
                  highestVisit > 0
                    ? "defaultTag default_tag purple_tag"
                    : "defaultTag default_tag yellow_tag"
                }
              >
                Visits: {highestVisit}
              </Tag>
            )}
          </div>
        </div>

        <Card className="innerCard">
          <div className="innerCardBox">
            {serviceGroup?.services?.some(
              (item: { frequency: string }) => item.frequency !== "one_time"
            ) ? (
              <>
                <p>Hrs per visit:</p>
                <h3>{Number(hrsPerVisit?.toFixed(2)).toLocaleString()}</h3>
              </>
            ) : (
              <>
                <p>Labor Hours:</p>
                <h3>{Number(hrsPerVisit?.toFixed(5)).toLocaleString()}</h3>
              </>
            )}
          </div>
          <div className="innerCardBox">
            <p>Total cost:</p>
            <h3>${Number(totalSubServiceCost?.toFixed(2)).toLocaleString()}</h3>
          </div>
          <div className="innerCardBox">
            <p>Total price:</p>
            <h3>
              ${Number(totalSubServicePrice?.toFixed(2)).toLocaleString()}
            </h3>
          </div>
          <div className="innerCardBox">
            <p>GM:</p>
            <h3>
              <InputNumber
                placeholder="0"
                controls={false}
                addonAfter={<span>%</span>}
                max={99}
                min={0}
                value={grossMargin ?? 0}
                style={{
                  background: grossMargin > 0 ? "transparent" : "#FFF9D9",
                }}
                onChange={(newGM) => {
                  const value = Number(newGM);

                  setGroupedData((prevData: any) => {
                    return prevData.map((serviceLine: any) => {
                      return {
                        ...serviceLine,
                        service_groups: serviceLine?.service_groups?.map(
                          (group: { id: string; services: [] }) => {
                            // console.log("group", group.id, serviceGroup?.id);
                            if (group.id === serviceGroup?.id) {
                              return {
                                ...group,
                                gross_margin_perc: value,
                                services: group?.services?.map(
                                  (service: any) => {
                                    const totalPrice =
                                      (service?.total_cost * 100) /
                                      (100 - Number(value) || 0);
                                    return {
                                      ...service,
                                      gross_margin_perc: value,
                                      total_price: totalPrice,
                                    };
                                  }
                                ),
                              };
                            }
                            return group;
                          }
                        ),
                      };
                    });
                  });
                }}
                className="serviceLineInput"
              />
            </h3>
          </div>
        </Card>

        <div className="estimateDropdown">
          <Dropdown
            menu={{ items: serviceItems }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(x) => {
                x.stopPropagation();
                // setServiceLineIdRecord(groupData?.service_line_id);
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "36px",
                width: "36px",
                backgroundColor: "transparent",
                border: "1px solid #DEE5E6",
                borderRadius: "8px",
              }}
              className="only_icon"
              icon={<MoreOutlined />}
              ref={dropdownRef}
            />
          </Dropdown>
        </div>
      </div>

      {serviceGroup?.services?.length > 0 && (
        <div className="estimateSubservice">
          <Collapse
            items={[
              {
                key: "1",
                label: (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "4px",
                        fontWeight: "700",
                        color: "#151718",
                        paddingLeft: "5px",
                      }}
                    >
                      Subservices
                      <Tag>{serviceGroup?.services?.length || 0}</Tag>
                    </div>
                    {/* <Button icon={<PlusIcon />} /> */}
                  </div>
                ),
                children: (
                  <div className="subServiceTableWrapper">
                    <SubServiceTable
                      data={serviceGroup?.services}
                      setActiveRecord={setActiveRecord}
                      setActiveType={setActiveType}
                      companyId={companyId}
                      parentId={""}
                      setGroupedData={setGroupedData}
                      groupedData={groupedData}
                      serviceLineId={groupData?.service_line_id}
                      serviceGroupId={serviceGroup?.id}
                      laborRate={groupData?.labor_rate}
                      groupIndex={groupIndex}
                      setHrsPerVisit={setHrsPerVisit}
                      setActiveServiceLineId={setActiveServiceLineId}
                      setActiveServiceId={setActiveServiceId}
                    />
                  </div>
                ),
              },
            ]}
            defaultActiveKey={["1"]}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
          />
        </div>
      )}
      <PopUp {...confirmDeleteService} />
    </Card>
  );
}
